export interface Taxon {
    id: number;
    name: string;
    permalink: string;
}
